import { Theme } from '@material-ui/core/styles';

import { ProjectSectionType, PROJECT_STATUS } from '../interfaces/project';
import { IUser } from '../interfaces/user';
import { invalidInfo } from './validations';
import { ApplicationInterface } from '../interfaces/application';

export const createTemplateApp = (app: ApplicationInterface, user: IUser): ApplicationInterface => {
  const date = `${new Date(Date.now()).toISOString().slice(0, -5)}Z`;

  return {
    info: {
      name: '',
      username: user.username,
      organisationId: user.organisationId,
      applicationId: app.info.applicationId,
      cluster: user.cluster,
      website: null,
      platforms: [],
      country: user.country || 'United Kingdom',
      version: '0.0.1',
      appLinks: {},
      privacyUrl: null,
      termsUrl: null,
      supportEmail: null,
      dataUsePurpose: app.info.dataUsePurpose,
    },
    dateCreated: date,
    lastUpdated: date,
    setup: {
      namespace: app.setup.namespace,
      type: 'app',
      validRedirectUris: [],
      status: app.setup.status || PROJECT_STATUS.TEST,
    },
    assets: {
      ...app.assets,
    },
  };
};

export const nullifyUrls = (app: ApplicationInterface): ApplicationInterface => {
  if (!app.info.website) app.info.website = null;
  // Re-add when AppLinks are hooked to state.
  // if (app.info.appLinks) {
  //   if (!app.info.appLinks.android) app.info.appLinks.android = null;
  //   if (!app.info.appLinks.ios) app.info.appLinks.ios = null;
  //   if (!app.info.appLinks.web) app.info.appLinks.web = null;
  // }

  if (!app.info.privacyUrl) app.info.privacyUrl = null;
  if (!app.info.termsUrl) app.info.termsUrl = null;

  return app;
};

export const isAppReadyForReview = (app: ApplicationInterface): boolean => {
  if (invalidInfo(app.info)) return false;
  if (!app.rating?.rating || app.rating.rating === 'TBD') return false;
  if (!app.assets || !app.assets.appLogoUrl?.contentUrl) return false;
  if (!app.setup.validRedirectUris || app.setup.validRedirectUris.length === 0) return false;
  if (!app.info.hasPermissionsForm) return false;

  return true;
};

export const getIconColour = (type: ProjectSectionType, theme: Theme) => {
  switch (type) {
    case 'alert':
      return theme.palette.error.main;
    case 'complete':
      return theme.palette.success.main;
    default:
      return theme.palette.grey[700];
  }
};
